"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Fab_1 = __importDefault(require("@material-ui/core/Fab"));
var Add_1 = __importDefault(require("@material-ui/icons/Add"));
var react_router_dom_1 = require("react-router-dom");
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var useStyles = makeStyles_1["default"](function (theme) { return ({
    back: {
        marginTop: theme.spacing(1.5)
    }
}); });
var AddButton = function (props) {
    var classes = useStyles();
    var onClick = props.onClick;
    return (react_1["default"].createElement(react_router_dom_1.Link, { to: onClick, className: classes.back },
        react_1["default"].createElement(Fab_1["default"], { color: "primary", "aria-label": "add", size: "small" },
            react_1["default"].createElement(Add_1["default"], null))));
};
exports["default"] = AddButton;
